import { dateI18n } from '@wordpress/date';
import { Fragment, useState } from '@wordpress/element';
import { DatePicker as PickDate, Popover, Button, PanelBody } from '@wordpress/components';
import { InspectorControls } from '@wordpress/block-editor';
import { __ } from '@wordpress/i18n';
import './style.scss';

const DatePicker = {
  title: __('Date Picker'),
  description: __('Date Picker block for the ABS theme'),
  icon: 'calendar-alt',
  attributes: {
    date: {
      type: 'string',
    },
    timestamp: {
      type: 'number'
    }
  },
  edit: ({ className, attributes, setAttributes }) => {
    const { date } = attributes;
    const [openDatePopup, setOpenDatePopup] = useState( false );
    const [ currentDate, setDate ] = useState( new Date() );
    const updateDate = (newDate) =>{
      setDate( newDate );
      setAttributes({ date: newDate })
    }

    const myIcon = (
      <svg className="svg-icon" viewBox="0 0 20 20">
        <path d="M16.557,4.467h-1.64v-0.82c0-0.225-0.183-0.41-0.409-0.41c-0.226,0-0.41,0.185-0.41,0.41v0.82H5.901v-0.82c0-0.225-0.185-0.41-0.41-0.41c-0.226,0-0.41,0.185-0.41,0.41v0.82H3.442c-0.904,0-1.64,0.735-1.64,1.639v9.017c0,0.904,0.736,1.64,1.64,1.64h13.114c0.904,0,1.64-0.735,1.64-1.64V6.106C18.196,5.203,17.461,4.467,16.557,4.467 M17.377,15.123c0,0.453-0.366,0.819-0.82,0.819H3.442c-0.453,0-0.82-0.366-0.82-0.819V8.976h14.754V15.123z M17.377,8.156H2.623V6.106c0-0.453,0.367-0.82,0.82-0.82h1.639v1.23c0,0.225,0.184,0.41,0.41,0.41c0.225,0,0.41-0.185,0.41-0.41v-1.23h8.196v1.23c0,0.225,0.185,0.41,0.41,0.41c0.227,0,0.409-0.185,0.409-0.41v-1.23h1.64c0.454,0,0.82,0.367,0.82,0.82V8.156z"></path>
      </svg>
    );

    return (
      <Fragment>
        <div className={className}>
          <p className={'date'}>
          { date ? dateI18n( 'd.m.Y', date ) : __('Select a date') }
          </p>
        </div>
        <InspectorControls>
          <PanelBody title={__('Date')}>
            <PickDate
              currentDate={date || new Date()}
              onChange={updateDate}
            />
          </PanelBody>
        </InspectorControls>
      </Fragment>
    );
  },

  save: ({ attributes }) => {
    const { date } = attributes;
    return dateI18n( 'Y-m-d', date );
  },
};

export default DatePicker;
